import { render, staticRenderFns } from "./drugImportPersonnel.vue?vue&type=template&id=688fc702&scoped=true"
import script from "./drugImportPersonnel.vue?vue&type=script&lang=js"
export * from "./drugImportPersonnel.vue?vue&type=script&lang=js"
import style0 from "./drugImportPersonnel.vue?vue&type=style&index=0&id=688fc702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688fc702",
  null
  
)

export default component.exports